import { t } from "@workspace/strings/web";
import { tickerDurationSec, tickerItems } from "@/player/lib/widgets";

/**
 * Scrolling marquee of config.items[]. Pure CSS animation (translateX keyframes
 * injected once) — no timers, no reflow churn on a TV box.
 */
export function TickerWidget({
  config,
  title,
}: {
  config: Record<string, unknown> | null;
  title: string;
}) {
  const items = tickerItems(config);
  if (items.length === 0) {
    return (
      <div
        className="flex h-full w-full items-center justify-center bg-background text-muted-foreground"
        data-testid="widget-ticker"
      >
        {t("player.widgets.ticker.empty")}
      </div>
    );
  }
  const durationSec = tickerDurationSec(items);
  const line = items.join("   •   ");

  return (
    <div
      className="flex h-full w-full flex-col justify-center bg-background overflow-hidden"
      data-testid="widget-ticker"
    >
      <style>{`@keyframes omni-ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
      <div className="px-[4vw] pb-[2vh] text-muted-foreground text-[2.5vw]">
        {title}
      </div>
      <div className="w-full overflow-hidden border-y bg-card py-[2vh]">
        <div
          className="inline-flex whitespace-nowrap will-change-transform text-foreground text-[4vw] font-medium"
          style={{ animation: `omni-ticker ${durationSec}s linear infinite` }}
        >
          {/* Rendered twice so -50% loops seamlessly. */}
          <span className="pr-[6vw]">{line}</span>
          <span className="pr-[6vw]" aria-hidden="true">
            {line}
          </span>
        </div>
      </div>
    </div>
  );
}
